module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tPossédez-vous une épargne ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isSavings
    },
    on: {
      "change": function($event) {
        _vm.isSavings = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.isSavings) ? _c('div', [_c('div', {
    staticClass: "ctn-add-children row"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "object": true,
      "items": _vm.savingsData,
      "selected": _vm.typeToAdd
    },
    on: {
      "change": function($event) {
        _vm.typeToAdd = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": _vm.addSaving
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "ctn-childrens"
  }, _vm._l((_vm.savingsRow), function(saving, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-children"
    }, [_c('div', {
      staticClass: "type-children row"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(saving.type) + " "), _c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.removeSaving(key)
        }
      }
    }, [_vm._v("supprimer")])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label three",
      class: {
        error: _vm.errors.has('montant' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'montant' + (key + 1)
      }
    }, [_vm._v("Montant actuel")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (saving.fields.value),
        expression: "saving.fields.value"
      }],
      key: 'amount' + key,
      attrs: {
        "type": "text",
        "name": 'montant' + (key + 1)
      },
      domProps: {
        "value": (saving.fields.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(saving.fields, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.currencies,
        "selected": saving.fields.currency
      },
      on: {
        "change": function($event) {
          saving.fields.currency = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('montant' + (key + 1))))])]), _vm._v(" "), (saving.fields.opening_date != null) ? _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('date d\'ouverture' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'date d\'ouverture' + (key + 1)
      }
    }, [_vm._v("Date d'ouverture")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (saving.fields.opening_date),
        expression: "saving.fields.opening_date"
      }],
      key: 'opening' + key,
      attrs: {
        "type": "date",
        "name": 'date d\'ouverture' + (key + 1)
      },
      domProps: {
        "value": (saving.fields.opening_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(saving.fields, "opening_date", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('date d\'ouverture' + (key + 1))))])]) : _vm._e(), _vm._v(" "), (saving.fields.ownership_type != null) ? _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label"
    }, [_c('label', [_vm._v("Type de propriété")]), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.ownershipTypes
      },
      model: {
        value: (saving.fields.ownership_type),
        callback: function($$v) {
          _vm.$set(saving.fields, "ownership_type", $$v)
        },
        expression: "saving.fields.ownership_type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    })]) : _vm._e(), _vm._v(" "), (saving.fields.investment_name != null) ? _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('nom de l\'investissement' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": "nom de l'investissement"
      }
    }, [_vm._v("Nom du contrat")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (saving.fields.investment_name),
        expression: "saving.fields.investment_name"
      }],
      key: 'investmentName' + key,
      attrs: {
        "type": "text",
        "name": 'nom de l\'investissement' + (key + 1)
      },
      domProps: {
        "value": (saving.fields.investment_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(saving.fields, "investment_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('nom de l\'investissement' + (key + 1))))])]) : _vm._e(), _vm._v(" "), (saving.fields.bank_name != null) ? _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('nom de la banque' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": "nom d la banque"
      }
    }, [_vm._v("Nom de l'établissement")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (saving.fields.bank_name),
        expression: "saving.fields.bank_name"
      }],
      key: 'bankName' + key,
      attrs: {
        "type": "text",
        "name": 'nom de la banque' + (key + 1)
      },
      domProps: {
        "value": (saving.fields.bank_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(saving.fields, "bank_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('nom de la banque' + (key + 1))))])]) : _vm._e()])
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3da351a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Savings.vue
// module id = 1110
// module chunks = 0